import * as ko from 'knockout';
import { log } from '../../../debug';
import { formatMessage } from '../../../i18n/data';
import { IItemDefinitionWidgetParams, ItemMode } from '../../../model/interfaces';
import { findInRingBuffer } from '../../../new_array';
import { focusManager } from '../../../ui/focusmanager';
import { UIAction } from '../../../ui/uiAction';
import { AbstractItemDefinition } from '../../base_itemdefinition';
import * as WIDGET_HEADER from '../../kosovo/widgets/header/widget';
import { InAppComboData, InAppComboData_SubItem } from "../../model/inapplicationcombo/InAppComboData";
import { GetSession } from '../../model/session';
import * as FACTORY from '../factory';
import * as i18n from './../../../i18n/i18n';
import { htmlString } from './widget.html.g';

const WIDGET_NAME = 'itemdefinition-inapplicationcombo-interactive';

export type IParams = IItemDefinitionWidgetParams;

class SubItem {
    private index: number;
    constructor(readonly model: MyModel, readonly _data: InAppComboData_SubItem) {
        this.itemDocRefId = _data.itemDocRefId;
        const nr = this._data.index + 1;
        const title = formatMessage(i18n.t(['itemdefinition.inapplicationcombo.interactive.PART_NR']), { nr });
        this.title(title);
        this.itemType(_data.itemType);

    }
    public readonly itemDocRefId: string;

    public readonly title = ko.observable('');
    public readonly itemType = ko.observable('');

    public readonly select = new UIAction(undefined, async () => {
        await this.model.selectSubItem.intent(this.itemDocRefId);
    });

    public readonly isDone = ko.pureComputed(() => {
        return this.model.data.meta.session.getItemData(this._data.itemDocRefId).IsInteractionComplete();
    });

    public readonly cssClass = ko.pureComputed(() => {
        if (this.model.selectedSubItem().itemDocRefId === this.itemDocRefId) {
            return 'ATTEMPTING';
        }
        return 'NOTATTEMPTED';
    });
}

export class MyModel extends AbstractItemDefinition {
    public readonly itemType = FACTORY.id;

    public readonly itemId: string;
    public readonly sessionId: string;
    public readonly mode = ko.observable<ItemMode>();
    public readonly loaded = ko.observable(false);

    //public readonly focusId: string;
    public readonly isFocused = ko.pureComputed(() => {
        if (!focusManager.isFocused()) {
            return false;
        }
        const topItemFocus = focusManager.topItemFocus();
        if (!topItemFocus) {
            return false;
        }
        /*
        if (topItemFocus.focusId !== this.focusId) {
            return false;
        }
        */
        return true;
    });

    public readonly showItemSwitcher = ko.pureComputed(() => {
        return this.subItems.length > 1;
    });

    public readonly data: InAppComboData;

    constructor(readonly params: IParams) {
        super();
        this.itemId = params.itemId;

        const mode = params.mode;
        if (mode !== 'INTERACTIVE') {
            throw new Error(`${WIDGET_NAME} - only interactive mode supported!`);
        }

        this.mode('INTERACTIVE');
        this.sessionId = params.sessionId;

        const item = GetSession(this.sessionId).GetItemModel(this.itemId);
        const data = item.data;
        if (!(data instanceof InAppComboData)) {
            throw new Error();
        }
        this.data = data;
        this.subItems = data.subItems.map(x => new SubItem(this, x));
    }


    public readonly headerParams = ko.pureComputed(() => {
        const retVal: WIDGET_HEADER.IParams = {
            questionHTML: this.questionHTML(),
            headerText: this.headerText(),
            mode: this.mode()
        };
        return retVal;
    });

    private async gremlins() {
        if (!this.loaded()) {
            return true;
        }
        if (!this.isFocused()) {
            return false;
        }
        if (this.hasSubItems()) {
            const curSubItem = this.selectedSubItem();
            if (curSubItem) {
                if (!curSubItem.isDone()) {
                    return false;
                }
            }
            const subItems = this.subItems;
            const next = findInRingBuffer(subItems, subItems.findIndex(x => x === this.selectedSubItem()), x => !x.isDone(), 'any');
            if (next) {
                log(`Select next sub item`);
                await next.select.invoke();
                return true;
            }
        }
        return false;
    }


    public async initialize() {
        this.registerGremlin({
            name: `${WIDGET_NAME} ${this.itemId}`,
            action: () => this.gremlins()
        });
        await super.initialize();
        log(`${WIDGET_NAME} initialize in mode ${this.mode()} (item: ${this.itemId}`);

        await this.OnRefresh();

        this.loaded(true);
    }

    public readonly isInFocusMode = ko.pureComputed(() => {
        const topItem = focusManager.topItemFocus();
        if (!topItem) {
            return false;
        }
        return !!topItem;
    });
    public readonly noSubItemsText = ko.pureComputed(() => {
        return i18n.t(['itemdefinition.inapplicationcombo.interactive.NO_SUBITEMS_HAVE_BEEN_ADDED_YET']);
    });

    public readonly hasSubItems = ko.pureComputed(() => {
        return this.subItems.length > 0;
    });


    public readonly subItems: SubItem[];

    public readonly selectedSubItem = ko.pureComputed(() => {
        return this.subItems.find(x => x.itemDocRefId === this.data.selectedSubItemId());
    });

    public readonly questionHTML = ko.pureComputed(() => this.data.questionHTML);
    public readonly headerText = ko.pureComputed(() => this.data.headerText);


    public readonly selectSubItem = new UIAction<string>(undefined, async (e, subItemDocRefId) => {
        await this.data.selectSubItem(subItemDocRefId);
    });
}

export function create(params: IParams, componentInfo: ko.components.ComponentInfo) {
    const retVal = new MyModel(params);
    retVal.DoInit({ WIDGET_NAME });
    return retVal;
}

ko.components.register(WIDGET_NAME, {
    viewModel: {
        createViewModel: create
    },
    template: htmlString.replace(/@@@/g, WIDGET_NAME)
});
